import type { LibraryEntry, RecordKind } from "../api/contract";

export const KIND_LABELS: Record<RecordKind, string> = {
  profile: "About you",
  copy: "Text",
  service: "Services",
  project: "Projects",
  faq: "Questions",
  link: "Links",
  media: "Photos",
  contact: "Contact",
  social: "Social links",
  item: "Items",
  post: "Posts",
};

/** A link an owner may give an item: web, email or phone. The server checks it again. */
export function isValidItemLink(value: string): boolean {
  return /^(?:https?:\/\/\S+|mailto:\S+|tel:\S+)$/i.test(value.trim());
}

export interface LibraryGroup {
  kind: RecordKind;
  label: string;
  entries: LibraryEntry[];
}

/** Keeps the content API's order while putting related records in one collection. */
export function groupEntriesByKind(entries: LibraryEntry[]): LibraryGroup[] {
  const groups = new Map<RecordKind, LibraryEntry[]>();
  entries.filter((entry) => entry.kind !== "media").forEach((entry) => {
    groups.set(entry.kind, [...(groups.get(entry.kind) ?? []), entry]);
  });
  return [...groups].map(([kind, grouped]) => ({ kind, label: KIND_LABELS[kind], entries: grouped }));
}

/** Human-readable locations available from the current content response. */
export function usedIn(entry: LibraryEntry): string[] {
  if (entry.shared) return ["Every page"];
  return entry.usedOn.map((page) => page.title);
}

export function isUnused(entry: LibraryEntry): boolean {
  return !entry.shared && entry.usedOn.length === 0;
}

export function filterUnusedPhotos(entries: LibraryEntry[], unused: boolean): LibraryEntry[] {
  const photos = entries.filter((entry) => entry.kind === "media");
  return unused ? photos.filter(isUnused) : photos;
}
